var map = {
	"./bg.jpg": "0812",
	"./bg@2x.jpg": "7621",
	"./game/1-1.jpg": "cf6a",
	"./game/1-2.jpg": "2ff1",
	"./game/1-3.jpg": "e8de",
	"./game/1-4.jpg": "8757",
	"./game/2-1.jpg": "fd82",
	"./game/2-2.jpg": "7bda",
	"./game/2-3.jpg": "0b46",
	"./game/2-4.jpg": "f6b8",
	"./game/3-1.jpg": "a063",
	"./game/3-2.jpg": "1de0",
	"./game/3-3.jpg": "71d6",
	"./game/3-4.jpg": "3a71",
	"./game/4-1.jpg": "f34d",
	"./game/4-2.jpg": "6b94",
	"./game/4-3.jpg": "3fd8",
	"./game/4-4.jpg": "ca91",
	"./game/5-1.jpg": "abba",
	"./game/5-2.jpg": "92e2",
	"./game/5-3.jpg": "d2b0",
	"./game/5-4.jpg": "c190",
	"./hardware/1-1.jpg": "94bc",
	"./hardware/1-2.jpg": "df4b",
	"./hardware/1-3.jpg": "7bc9",
	"./hardware/1-4.jpg": "3582",
	"./hardware/2-1.jpg": "872c",
	"./hardware/2-2.jpg": "4c02",
	"./hardware/2-3.jpg": "571a",
	"./hardware/2-4.jpg": "9461",
	"./hardware/3-1.jpg": "59d3",
	"./hardware/3-2.jpg": "2b7b",
	"./hardware/3-3.jpg": "1084",
	"./hardware/3-4.jpg": "8ee9",
	"./hardware/4-1.jpg": "cfd6",
	"./hardware/4-2.jpg": "fc82",
	"./hardware/4-3.jpg": "c6a8",
	"./hardware/4-4.jpg": "aac4",
	"./hardware/5-1.jpg": "4140",
	"./hardware/5-2.jpg": "3f1e",
	"./hardware/5-3.jpg": "9e70",
	"./hardware/5-4.jpg": "18df",
	"./hardware/6-1.jpg": "3e18",
	"./hardware/6-2.jpg": "9ce2",
	"./hardware/6-3.jpg": "64dc",
	"./hardware/6-4.jpg": "eb03",
	"./industry/1-1.jpg": "5513",
	"./industry/1-2.jpg": "bbba",
	"./industry/1-3.jpg": "5c2a",
	"./industry/1-4.jpg": "0270",
	"./industry/2-1.jpg": "62ea",
	"./industry/2-2.jpg": "e1ac",
	"./industry/2-3.jpg": "c827",
	"./industry/2-4.jpg": "dd15",
	"./industry/3-1.jpg": "8412",
	"./industry/3-2.jpg": "7a13",
	"./industry/3-3.jpg": "72bd",
	"./industry/3-4.jpg": "db33",
	"./industry/4-1.jpg": "93a0",
	"./industry/4-2.jpg": "d009",
	"./industry/4-3.jpg": "d856",
	"./industry/4-4.jpg": "ca1a",
	"./industry/5-1.jpg": "a142",
	"./industry/5-2.jpg": "301a",
	"./industry/5-3.jpg": "3e9d",
	"./industry/5-4.jpg": "b7d8",
	"./industry/6-1.jpg": "8a67",
	"./industry/6-2.jpg": "883e",
	"./industry/6-3.jpg": "fb9e",
	"./industry/6-4.jpg": "edaa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c43";